import { IsNotEmpty, IsUUID } from 'class-validator';

import { NodeToSignDto } from './node-to-sign.dto';

export class CompanyBatchSignEventDto {
  @IsUUID()
  @IsNotEmpty()
  event_id: string;

  @IsNotEmpty()
  documents: NodeToSignDto[];
}
